import axiosInstance from '../api';

export interface NewClientPause {
  active: boolean;
  pauseStart: string | null;
}

/** Sunset mode: Homepoint is winding down and takes no new clients. */
export interface Sunset {
  active: boolean;
  start: string | null;
}

interface HealthResponse {
  status: string;
  database: string;
  timestamp: string;
  newClientPause?: NewClientPause;
  sunset?: Sunset;
}

const healthService = {
  find: async (): Promise<HealthResponse> => {
    const response = await axiosInstance.get('/health');
    return response.data;
  },
};

export default healthService;
